import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';
import type { StandbyData } from './ui';

/**
 * Represents the active Cast session state.
 *
 * - `userToken` is received from the sender via the custom message channel.
 * - `userId`, `userName`, `userAvatar` are populated via Hermes after auth.
 * - `standbyData` holds the user profile + catalog highlights for the standby screen.
 * - `loadRequestData` holds the last LOAD request for replay/queue logic.
 */
export interface CastSession {
  userToken: string;
  refreshToken: string;
  userId: string;
  userName: string;
  userAvatar: string;
  appVersion: string;
  userAudio: string;
  userSub: string;
  standbyData: StandbyData | null;
  loadRequestData: LoadRequestData | null;
}

export function createDefaultSession(): CastSession {
  return {
    userToken: '',
    refreshToken: '',
    userId: '',
    userName: '',
    userAvatar: '',
    appVersion: '',
    userAudio: 'original',
    userSub: 'pt-br',
    standbyData: null,
    loadRequestData: null,
  };
}
